import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/ui/button';
import { useSsoHandoff } from '../hooks/useSsoHandoff';

interface SsoHandoffButtonProps {
  subscriptionId: string;
  className?: string;
}

export function SsoHandoffButton({ subscriptionId, className }: SsoHandoffButtonProps) {
  const { t } = useTranslation();
  const { mutate, isPending, error } = useSsoHandoff();

  const handleClick = () => {
    mutate(subscriptionId, {
      onError: () => {
        alert(t('subscriptions.ssoHandoff.error'));
      },
    });
  };

  return (
    <div className={className}>
      <Button onClick={handleClick} isLoading={isPending} disabled={isPending} variant="default">
        {isPending
          ? t('subscriptions.ssoHandoff.redirecting')
          : t('subscriptions.actions.goToProduct')}
      </Button>
      {error && (
        <p className="mt-1.5 text-xs text-destructive">{t('subscriptions.ssoHandoff.error')}</p>
      )}
    </div>
  );
}
